import { apiConstants } from '../../apiConstant'
import { formDataCommonFunction, serviceCall } from '../../serviceCall'

export const ticketCallRequest = (data, callback, errorCallBack) => {
  // return async (dispatch) => {
  //   serviceCall({
  //     url: apiConstants.TICKET.GET_CALL_REQUESTS_FOR_TICKET,
  //     method: 'Post',
  //     data: data,
  //   })
  //     .then((response) => {
  //       callback && callback(response.data)
  //     })
  //     .catch((error) => {
  //       errorCallBack && errorCallBack(error.response)
  //     })
  // }

  return async (dispatch) => {
 
    formDataCommonFunction(data,apiConstants.TICKET.GET_CALL_REQUESTS_FOR_TICKET)
      .then((response) => {
        callback && callback(response)
      })
      .catch((error) => {
        errorCallBack && errorCallBack(error.response)
      })
  }
}
